var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingGoals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#FAFAFA;}\n\t.st2{fill:#E0E0E0;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#D3D3D3;}\n\t.st5{fill:#B7B7B7;}\n\t.st6{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{fill:#9E9E9E;}\n\t.st8{fill:#A5A5A5;}\n\t.st9{fill:none;}\n\t.st10{fill:#DDDDDD;}\n\t.st11{opacity:0.3;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#E4897B;}\n\t.st14{fill:#263238;}\n\t.st15{opacity:0.3;enable-background:new    ;}\n\t.st16{fill:#042b62;}\n\t.st17{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st18{opacity:0.2;}\n\t.st19{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st20{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st21{opacity:0.2;enable-background:new    ;}\n\t.st22{fill:#DE5753;}\n\t.st23{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.5,
    y: 435.9,
    className: "st0",
    width: 40,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.4,
    y: 439.2,
    className: "st0",
    width: 10.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 424.6,
    className: "st0",
    width: 23.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 426.7,
    className: "st0",
    width: 52.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.9,
    y: 426.7,
    className: "st0",
    width: 7.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 431.8,
    className: "st0",
    width: 113.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.3,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 244.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 250,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 255.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 261,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 266.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 272.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 277.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 283.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.3,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.4,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 279.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 230.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 235.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 241.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 279.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 359,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 364.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 359,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 364.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 370,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 347.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 353.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 359,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 364.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 370,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 347.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 347.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 248.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 253.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 259.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 265,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 270.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 276,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 281.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 287,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 349.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 388.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 393.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 349.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 288.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 294.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 299.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 305.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 310.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 349.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.8,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 329.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 334.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 340.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 345.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 351.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 356.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 362.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 367.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 373.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 378.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 384.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 389.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.8,
    y: 395.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 329.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 334.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 340.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 345.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 351.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 356.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 362.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 367.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 373.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 378.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 384.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 389.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 395.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 329.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 334.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 340.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 345.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 351.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 356.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 362.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 367.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 373.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 378.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 384.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 389.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 395.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 400.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 330.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 336.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 341.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 347.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 352.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 358.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 363.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 369.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 374.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 380.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 397.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 330.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 336.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 341.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 347.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 352.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 358.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 363.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 369.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 374.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 391.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 397.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 330.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 336.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 341.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 347.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 352.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 358.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 363.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 369.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 385.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 391.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 397.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 279.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 335.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 351.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 357.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 362.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.1,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 279.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 362.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.9,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 246.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 252.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 257.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 263.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 268.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 274.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 279.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 351.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 357.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.7,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 349.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 388.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 393.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 399.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 388.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 393.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 399.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 316.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 321.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 327.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 333,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 338.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 344,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 355,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 360.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 366.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 371.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 377.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 382.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 388.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 393.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.7,
    y: 399.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 335.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 351.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 362.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 373.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 379.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 390.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 396,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 401.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 335.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 351.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 373.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 385,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 390.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 396,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 401.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 285.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 290.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 296.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 302,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 307.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 313,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 318.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 324.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 329.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 335.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 340.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 346.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 351.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 357.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 368.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 379.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 385,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 390.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 396,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 401.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 316.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 322.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 328,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 333.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 339,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 344.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 361.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 366.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 372.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 377.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 383.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 388.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 394.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 316.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 322.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 328,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 333.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 339,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 344.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 361.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 366.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 372.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 377.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 383.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 388.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 399.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 347.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 359,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 364.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 370,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 375.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 381,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 386.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 392.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 397.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 292.6,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 298.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 303.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 309.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 314.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 320.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 325.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 331.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 336.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 342.3,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 347.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 353.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 359,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 364.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 370,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 375.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 381,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 386.5,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 392.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 397.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 314.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 319.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 325.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 330.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 336.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 341.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 347.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 352.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 358.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.2,
    y: 363.9,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 314.1,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 319.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 325.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 330.7,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 336.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 341.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 347.2,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 352.8,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 358.4,
    className: "st1",
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.3,284.4l-15-1.7c-0.7-0.1-1.2-0.7-1.1-1.3c0.1-0.7,0.7-1.2,1.3-1.1h0.2L229.3,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M232.9,330.6l1.2,11.1c0,0.4-0.2,0.6-0.5,0.7c-0.2,0.1-0.6-0.2-0.7-0.5c0,0,0,0,0-0.1V330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.9,321.8l9.7,10.5c0.2,0.2,0.2,0.6,0,0.8l0,0c-0.2,0.2-0.6,0.2-0.8,0l0,0l0,0L261.9,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.4,280.8l-9.6-3.5c-0.4-0.1-0.5-0.5-0.4-0.7l0,0c0.1-0.4,0.5-0.5,0.7-0.4h0.1L227.4,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.1,290.8l-7.9,2.2c-0.4,0.1-0.6-0.1-0.7-0.4l0,0c-0.1-0.4,0.1-0.6,0.4-0.7l0,0h0.1L226.1,290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.3,294l-5.1,5.9c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8h0.1L231.3,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.3,298.9l4.2,5.6c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0l0,0v-0.1L244.3,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.8,285l4.8-0.6c0.4,0,0.6,0.2,0.7,0.5c0.1,0.2-0.2,0.6-0.5,0.7h-0.1L247.8,285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.5,361.8l1.2,11.1c0,0.4-0.2,0.6-0.5,0.6l0,0c-0.4,0-0.6-0.2-0.6-0.5v-0.1v-11.1H403.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.7,130l9.7,10.5c0.2,0.2,0.2,0.6,0,0.8l0,0c-0.2,0.2-0.6,0.2-0.8,0l0,0l0,0L229.7,130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.1,102.2l-5.1,5.9c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8h0.1L199.1,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.6,93.1l4.8-0.6c0.4,0,0.6,0.2,0.7,0.5l0,0c0,0.4-0.2,0.6-0.5,0.7h-0.1L215.6,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.4,100c0.1,0,0.2,0,0.4,0c0.5,0,0.8,0.5,0.8,1c0,0.5-0.5,0.8-1,0.8l0,0l-4.8-0.5L352.4,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,97.9L93.2,97.9c-0.2,0.2-0.6,0.1-0.8-0.1c-0.2-0.2-0.1-0.6,0.1-0.7l8.9-6.9L93.2,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106,103.7L104.6,90l2.7,13.5l0,0c0.1,0.2-0.1,0.6-0.5,0.6S106,104,106,103.7L106,103.7L106,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.2,88.9l10.3,5.2l0,0c0.2,0.1,0.4,0.5,0.1,0.7c-0.1,0.2-0.5,0.4-0.7,0.1l0,0L107.2,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.2,81.9c0.2-0.1,0.6,0,0.7,0.4c0.1,0.2,0,0.6-0.4,0.7h-0.1l-12.3,3.4L119.2,81.9L119.2,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.1,73.9L111.1,73.9c0.1-0.2,0.5-0.4,0.7-0.1c0.2,0.1,0.4,0.5,0.1,0.7l0,0l-6.3,9.6L111.1,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.9,74.5l3.6,9.7l-4.6-9.3l0,0c-0.1-0.2,0.1-0.6,0.4-0.7C98.5,74.2,98.8,74.3,98.9,74.5L98.9,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.8,85.9c-0.2-0.1-0.5-0.4-0.5-0.6c0.1-0.2,0.4-0.5,0.6-0.5l9.7,1.9L90.8,85.9L90.8,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97,89.9c-0.4,0-0.6-0.2-0.6-0.5c0-0.2,0.1-0.6,0.5-0.6l0,0l5.2-0.5L97,89.9L97,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.4,93.6v0.1c-0.1,0.2-0.4,0.5-0.7,0.4c-0.2-0.1-0.5-0.4-0.4-0.7l0,0l1.1-3.9V93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108,92.5C108,92.5,108,92.7,108,92.5c0.2,0.4,0.1,0.7-0.2,0.8c-0.2,0.1-0.6,0-0.7-0.2l-1.8-4.1L108,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.1,87.8l5.1-0.2h0.1c0.4,0,0.5,0.4,0.5,0.6l0,0c-0.1,0.2-0.4,0.5-0.6,0.5L106.1,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.4,83.2l-0.7,0.6c0.2,0,0.5,0.1,0.6,0.4c0.1,0.4-0.1,0.6-0.4,0.7l-1.8,0.6l1-1.3l-2.7,2.1l3.3-3.7l0.1-0.1 c0.2-0.1,0.6,0,0.7,0.2C109.7,82.7,109.5,83.1,109.4,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.6,84l-0.2,0.7l-0.6-1.2c-0.1-0.4,0-0.7,0.4-0.8c0.1-0.1,0.4-0.1,0.5,0c0,0,0,0,0.1,0v-1.7v-0.1 c0.1-0.2,0.4-0.5,0.7-0.5c0.2,0.1,0.5,0.4,0.4,0.7l-1,4.4L103.6,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.2,86.4l-4.2-2.3c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0L102.2,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.5,101.5c-0.1,0.2-0.5,0.5-0.7,0.4c-0.2-0.1-0.5-0.5-0.4-0.7l0,0l1.3-3.4l-0.2,3.6 C100.6,101.4,100.5,101.5,100.5,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.7,99.3l-1.6-3.3l2.5,2.7l0.1,0.1c0.1,0.2,0,0.6-0.2,0.7C112.2,99.7,111.8,99.6,111.7,99.3L111.7,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.4,87.3c0.1,0,0.1,0,0.2,0c0.4,0,0.6,0.2,0.6,0.6s-0.2,0.6-0.6,0.6h-0.1l-3-0.4L118.4,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.5,77.5c0.2-0.1,0.6-0.1,0.7,0.1c0.1,0.2,0.1,0.6-0.1,0.7l0,0l-3.1,2.2L115.5,77.5 C115.3,77.7,115.5,77.5,115.5,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.1,73.3v-0.1c0-0.4,0.4-0.5,0.6-0.5l0,0c0.4,0,0.5,0.4,0.5,0.6l0,0l-0.4,3.9L104.1,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.8,80.7L91.5,79l-0.1-0.1c-0.2-0.2-0.2-0.6,0-0.7l0,0c0.2-0.2,0.6-0.2,0.8,0l0,0L94.8,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.3,92.2c-0.4,0-0.6-0.2-0.6-0.5c0-0.2,0.1-0.5,0.4-0.6l3.4-0.6l-3,1.7H89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,87.9c0,0-0.1,0-0.2,0c-0.4,0-0.5-0.4-0.5-0.6l0,0c0-0.4,0.4-0.5,0.6-0.5l3.6,0.6L97.6,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.6,91.3c-0.2,0.1-0.6-0.1-0.7-0.4c-0.1-0.4,0.1-0.6,0.4-0.7l0,0l2.7-0.7l-2.2,1.7 C98.8,91.3,98.6,91.3,98.6,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.2,93.1c-0.2-0.1-0.4-0.5-0.1-0.7l0,0l1.5-2.3l-0.5,2.7c0,0.1,0,0.1-0.1,0.2 C101.8,93.3,101.4,93.4,101.2,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.7,93.1c-0.4,0-0.6-0.2-0.6-0.6l0,0v-2.2l1.1,1.9c0.1,0.2,0,0.6-0.2,0.7C105.8,93.1,105.8,93.1,105.7,93.1 L105.7,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.9,89l1.9,1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2,0.1,0.6-0.1,0.8c-0.2,0.1-0.6,0.1-0.8-0.1l0,0L105.9,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.1,87l2.5-0.7c0.1,0,0.1,0,0.2,0c0.4,0,0.5,0.4,0.5,0.6l0,0c0,0.4-0.4,0.5-0.6,0.5l0,0L107.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.7,82.5c0.2,0.2,0.2,0.6,0,0.8l0,0l-1.2,1.5l0.2-1.8c0-0.1,0-0.2,0.1-0.4 C104.9,82.4,105.3,82.3,105.7,82.5L105.7,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.4,83.4c0.2-0.1,0.6-0.1,0.8,0.1l0,0c0.1,0.2,0.1,0.6-0.1,0.8l0,0l-1.7,1.1l0.8-1.8 C106.3,83.5,106.3,83.4,106.4,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100,83.7c-0.1-0.2,0-0.6,0.2-0.7s0.6,0,0.7,0.2l1.1,2.1l-1.9-1.3C100.1,83.8,100,83.8,100,83.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-17",
    className: "st3",
    cx: 255.7,
    cy: 457.3,
    rx: 234.5,
    ry: 13.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Factors--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.8,146.4c-19.1-12.1-24.7-37.5-12.6-56.6c12.1-19.1,37.5-24.7,56.6-12.6s24.7,37.5,12.6,56.6l0,0 C250.2,152.8,224.9,158.5,205.8,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.9,160.2c-0.4,0-0.6-0.2-0.6-0.5c0-0.4,0.2-0.6,0.5-0.7c0.7-0.1,1.6-0.2,2.4-0.4c0.4,0,0.6,0.1,0.7,0.5 c0.1,0.4-0.1,0.6-0.5,0.7c-0.8,0.1-1.6,0.2-2.4,0.4H233.9z M215.8,159.1h-0.1c-1.9-0.5-3.9-1.1-5.8-1.9c-0.4-0.1-0.5-0.5-0.4-0.7 c0.1-0.4,0.5-0.5,0.7-0.4l0,0c1.8,0.7,3.7,1.3,5.7,1.8c0.4,0,0.6,0.4,0.5,0.7C216.3,158.9,216.2,159.2,215.8,159.1L215.8,159.1z  M247.8,156.3c-0.2,0-0.5-0.1-0.5-0.4c-0.1-0.4,0-0.6,0.2-0.8c5.4-2.4,10.4-5.9,14.5-10.3c0.2-0.2,0.6-0.2,0.8-0.1 c0.2,0.2,0.2,0.6,0.1,0.8c0,0,0,0-0.1,0.1c-4.2,4.5-9.3,8-14.9,10.5C247.9,156.3,247.9,156.3,247.8,156.3L247.8,156.3z  M206.8,155.8c-0.1,0-0.1,0-0.2,0c-1.7-0.8-3.4-1.8-5-2.8c-3.5-2.3-6.8-5-9.7-8.1c-0.2-0.2-0.2-0.6-0.1-0.8 c0.2-0.2,0.6-0.2,0.8-0.1l0.1,0.1c2.8,3,5.9,5.7,9.4,7.9c1.6,1,3.1,1.9,4.8,2.7c0.2,0.1,0.5,0.5,0.2,0.8l0,0 C207.3,155.7,207,155.8,206.8,155.8L206.8,155.8z M264.9,143.1c-0.1,0-0.2,0-0.4-0.1c-0.2-0.2-0.2-0.6-0.1-0.8 c1.3-1.6,2.4-3.1,3.5-4.8l0.4-0.6c0.1-0.2,0.5-0.4,0.8-0.2l0,0c0.2,0.1,0.4,0.6,0.2,0.8l-0.4,0.6c-1.1,1.7-2.3,3.4-3.6,5 C265.2,143.1,265.1,143.1,264.9,143.1L264.9,143.1z M185.2,135.2c-0.2,0-0.5-0.1-0.5-0.4c-0.4-0.7-0.7-1.5-1.1-2.2 c-0.1-0.2,0-0.6,0.2-0.8l0,0c0.4-0.1,0.6,0,0.8,0.2c0.4,0.7,0.7,1.5,1.1,2.2c0.1,0.2,0,0.6-0.2,0.8l0,0 C185.5,135.2,185.4,135.2,185.2,135.2L185.2,135.2z M275.3,120.8L275.3,120.8c-0.5-0.1-0.6-0.4-0.6-0.7c0.1-0.7,0.2-1.6,0.4-2.4 c0-0.4,0.4-0.6,0.7-0.5c0.4,0.1,0.6,0.4,0.5,0.7l0,0c-0.1,0.8-0.2,1.6-0.4,2.4C275.8,120.6,275.6,120.8,275.3,120.8z M179.7,115.6 c-0.4,0-0.6-0.2-0.6-0.6c-0.1-1.1-0.1-2.2-0.1-3.4c0-1,0-1.8,0.1-2.8c0-0.4,0.4-0.6,0.6-0.6c0.4,0,0.6,0.4,0.6,0.6l0,0 c0,1-0.1,1.8-0.1,2.7s0,2.2,0.1,3.3C180.3,115.4,180,115.6,179.7,115.6L179.7,115.6L179.7,115.6z M275.7,106.3 c-0.4,0-0.6-0.2-0.6-0.5c-0.7-5.9-2.7-11.7-5.4-16.9c-0.1-0.2-0.1-0.6,0.2-0.8l0,0c0.2-0.1,0.6,0,0.8,0.2l0,0 c3,5.3,5,11.2,5.7,17.4c0,0.4-0.2,0.6-0.5,0.6l0,0H275.7z M180,106L180,106c-0.4,0-0.6-0.4-0.6-0.7c0.8-6,2.8-12,5.8-17.3 c0.1-0.2,0.5-0.4,0.8-0.2c0.2,0.1,0.4,0.5,0.2,0.8l0,0c-2.9,5.2-4.8,11-5.7,16.9C180.5,105.7,180.3,106,180,106L180,106z M268.3,86 c-0.2,0-0.4-0.1-0.5-0.2c-1.1-1.7-2.3-3.3-3.5-4.8c-0.2-0.2-0.2-0.6,0-0.8s0.6-0.1,0.8,0.1c1.3,1.6,2.5,3.1,3.6,5 c0.1,0.2,0.1,0.6-0.1,0.8C268.4,86,268.3,86,268.3,86L268.3,86z M192.9,79.1c-0.1,0-0.4-0.1-0.5-0.1c-0.2-0.2-0.2-0.6,0-0.8l0,0 c0.6-0.6,1.1-1.2,1.7-1.7c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8c0,0,0,0-0.1,0.1c-0.6,0.5-1.1,1.1-1.7,1.7 C193.2,79.1,193,79.1,192.9,79.1z M250.7,69.9c-0.1,0-0.2,0-0.2-0.1c-0.7-0.4-1.5-0.7-2.2-1.1c-0.2-0.1-0.5-0.5-0.2-0.7l0,0 c0.1-0.4,0.5-0.5,0.8-0.2l0,0c0.7,0.4,1.5,0.7,2.2,1.1c0.2,0.1,0.4,0.5,0.2,0.7l0,0C251,69.8,250.8,69.9,250.7,69.9L250.7,69.9z  M209.7,67.6c-0.2,0-0.5-0.1-0.6-0.4c-0.1-0.4,0-0.6,0.4-0.8c1.9-0.7,3.9-1.5,5.8-1.9c0.4-0.1,0.6,0.1,0.7,0.5 c0.1,0.4-0.1,0.6-0.5,0.7l0,0c-1.9,0.5-3.9,1.2-5.7,1.9C209.8,67.6,209.8,67.6,209.7,67.6z M237,65h-0.1c-5.9-1.1-12-1.1-17.8,0 c-0.4,0-0.6-0.1-0.7-0.5c0-0.4,0.1-0.6,0.5-0.7c6-1.1,12.2-1.1,18.3,0c0.4,0.1,0.5,0.4,0.5,0.7C237.5,64.7,237.2,65,237,65L237,65z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.8,146.4c-19.1-12.1-24.7-37.5-12.6-56.6c12.1-19.1,37.5-24.7,56.6-12.6s24.7,37.5,12.6,56.6l0,0 C250.2,152.8,224.9,158.5,205.8,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.4,102.7c-0.4,0-0.6-0.2-0.6-0.6s0.2-0.6,0.6-0.6c0.7,0,1.6-0.1,2.4-0.2c0.4,0,0.6,0.2,0.6,0.5l0,0 c0,0.4-0.2,0.6-0.5,0.6l0,0C368.1,102.6,367.3,102.7,366.4,102.7L366.4,102.7z M380.1,98.5c-0.4,0-0.6-0.2-0.6-0.6 c0-0.2,0.1-0.4,0.2-0.5c5.1-3.1,8.9-8,11-13.5c0.1-0.4,0.5-0.5,0.7-0.4c0.2,0.1,0.5,0.5,0.4,0.7c-2.2,5.8-6.2,10.8-11.5,14.1 C380.3,98.5,380.2,98.5,380.1,98.5L380.1,98.5z M349.4,97.5c-0.1,0-0.2,0-0.4-0.1c-1.7-1.2-3.3-2.5-4.6-4.1c-0.2-0.2-0.2-0.6,0-0.8 l0,0c0.2-0.2,0.6-0.2,0.8,0l0,0c1.3,1.5,2.8,2.8,4.4,4c0.2,0.2,0.4,0.6,0.1,0.8C349.7,97.4,349.5,97.5,349.4,97.5L349.4,97.5z  M342.7,90.6c-0.2,0-0.4-0.1-0.5-0.2c-3.1-4.6-4.8-10.2-4.8-15.7c0-0.6,0-1.2,0-1.8c0-0.4,0.4-0.6,0.6-0.6c0.4,0,0.6,0.4,0.6,0.6 l0,0c0,0.6,0,1.2,0,1.7c0,5.3,1.6,10.6,4.6,15c0.2,0.2,0.1,0.6-0.1,0.8C342.9,90.6,342.8,90.6,342.7,90.6z M392.4,81.2h-0.1 c-0.4-0.1-0.5-0.4-0.5-0.7l0,0c0.5-1.9,0.6-3.9,0.6-5.8c0-0.4,0.2-0.6,0.6-0.6s0.6,0.2,0.6,0.6c0,2.1-0.2,4.1-0.6,6.2 C392.9,81.1,392.7,81.2,392.4,81.2z M391.3,65.7c-0.2,0-0.5-0.1-0.6-0.4c-0.2-0.7-0.6-1.5-1-2.2c-0.1-0.2,0-0.6,0.2-0.8l0,0 c0.2-0.1,0.6,0,0.8,0.2l0,0c0.4,0.7,0.6,1.5,1,2.3c0.1,0.4,0,0.6-0.4,0.7L391.3,65.7z M341.5,61.9c-0.1,0-0.2,0-0.2-0.1 c-0.2-0.1-0.4-0.5-0.2-0.8l0,0c0.4-0.7,0.8-1.5,1.3-2.1c0.2-0.2,0.6-0.4,0.8-0.1c0.2,0.2,0.4,0.6,0.1,0.8l0,0 c-0.5,0.6-0.8,1.3-1.2,2.1C341.9,61.8,341.6,61.9,341.5,61.9L341.5,61.9z M383.1,54c-0.1,0-0.2,0-0.4-0.1 c-4.6-3.9-10.3-5.9-16.3-6.2c-0.4,0-0.6-0.2-0.6-0.6c0,0,0,0,0-0.1c0-0.4,0.2-0.6,0.6-0.6l0,0c6.3,0.1,12.2,2.4,17.1,6.4 c0.2,0.2,0.2,0.6,0.1,0.8C383.5,54,383.2,54,383.1,54L383.1,54z M356.9,49.1c-0.4,0-0.6-0.1-0.7-0.5c0-0.4,0.1-0.6,0.5-0.7 c1.9-0.6,4-1.1,6-1.3c0.4,0,0.6,0.2,0.7,0.5c0,0.4-0.2,0.6-0.6,0.7l0,0c-1.9,0.2-3.9,0.6-5.8,1.2C357,49,357,49.1,356.9,49.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 365.5,
    cy: 74.7,
    rx: 22.4,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 365.5,
    cy: 74.7,
    rx: 22.4,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365.6,62.6c4.5,0,8,3.5,8.1,8c0,2.9-1.6,5.6-4.1,7c-0.4,0.2-0.6,0.6-0.6,1h-6.8c0-0.4-0.2-0.7-0.6-1 c-3.9-2.2-5.2-7.1-3-10.9C360,64.1,362.7,62.7,365.6,62.6 M365.6,61.3c-5.1,0-9.2,4.1-9.2,9.3c0,3.3,1.8,6.4,4.7,8l0.1,1.1h8.9 l0.1-1.1c4.5-2.5,6-8.1,3.5-12.6C372,63.2,368.8,61.3,365.6,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.3,80.5h8.3c0.4,0,0.6,0.2,0.6,0.6v0.2c0,0.4-0.2,0.6-0.6,0.6h-8.3c-0.4,0-0.6-0.2-0.6-0.6v-0.2 C360.7,80.7,361,80.5,361.3,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.6,82.4h7.9c0.4,0,0.6,0.2,0.6,0.6v0.2c0,0.4-0.2,0.6-0.6,0.6h-7.9c-0.4,0-0.6-0.2-0.6-0.6V83 C361,82.6,361.2,82.4,361.6,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.9,84.3h7.1c0.4,0,0.6,0.2,0.6,0.6v0.2c0,0.4-0.2,0.6-0.6,0.6h-7.1c-0.4,0-0.6-0.2-0.6-0.6v-0.2 C361.3,84.6,361.6,84.3,361.9,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M362.7,86.3c1,1.6,3,1.9,4.6,1c0.4-0.2,0.7-0.6,1-1H362.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367,79.8L367,79.8c-0.1,0-0.2-0.1-0.2-0.2l0,0c0-0.2,0.2-4.5,1.5-6.4h-0.6c-0.1,0-0.2-0.1-0.2-0.2l-0.1-0.4 l-0.6,1.3c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0-0.2-0.1-0.2-0.2l-0.5-1.3l-0.5,1.3c-0.1,0.1-0.2,0.2-0.5,0.1l-0.1-0.1l-0.5-1.3L364,73 c0,0.1-0.1,0.2-0.2,0.2h-0.6c1.1,2.1,1.5,6.3,1.5,6.4c0,0.1-0.1,0.2-0.2,0.4l0,0c-0.1,0-0.2-0.1-0.4-0.2l0,0c0,0-0.4-5.1-1.6-6.7 c-0.1-0.1-0.1-0.2,0-0.4c0-0.1,0.1-0.1,0.2-0.1h1l0.4-0.8c0-0.1,0.1-0.2,0.2-0.2l0,0c0.1,0,0.2,0.1,0.2,0.2l0.5,1.3l0.5-1.3 c0-0.1,0.1-0.2,0.2-0.2l0,0c0.1,0,0.2,0.1,0.2,0.2l0.5,1.3l0.5-1.3c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2l0.4,0.8h1 c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2c-1.3,1.6-1.6,6.5-1.6,6.7C367.4,79.7,367.3,79.8,367,79.8L367,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107,257.4L107,257.4c-2.1-0.1-4.1-0.5-6-1c-0.4-0.1-0.5-0.5-0.4-0.7c0.1-0.4,0.4-0.5,0.7-0.5 c1.9,0.5,3.9,0.8,5.8,1c0.4,0,0.6,0.4,0.6,0.6C107.6,257.1,107.4,257.4,107,257.4L107,257.4z M97.6,255.2h-0.2 c-5.8-2.3-10.8-6-14.5-11.1c-0.2-0.2-0.1-0.6,0.1-0.8c0.2-0.2,0.6-0.1,0.8,0.1l0,0c3.5,4.8,8.3,8.5,13.9,10.6 c0.4,0,0.6,0.4,0.5,0.7C98.2,255.1,97.9,255.3,97.6,255.2L97.6,255.2z M124.5,253.6c-0.2,0-0.5-0.1-0.5-0.4c-0.1-0.2,0-0.6,0.2-0.8 l0,0c0.7-0.4,1.3-0.7,2.1-1.2c0.2-0.1,0.6-0.1,0.8,0.2c0.1,0.2,0.1,0.6-0.1,0.8c-0.7,0.5-1.5,0.8-2.2,1.2 C124.7,253.5,124.5,253.5,124.5,253.6L124.5,253.6z M135.3,244.1c-0.1,0-0.2,0-0.4-0.1c-0.2-0.2-0.4-0.6-0.1-0.8l0,0 c3.5-4.8,5.6-10.5,5.9-16.6c0-0.4,0.2-0.6,0.6-0.6l0,0c0.4,0,0.6,0.4,0.6,0.6l0,0c-0.4,6.2-2.5,12.1-6.2,17.2 C135.7,244,135.4,244.1,135.3,244.1L135.3,244.1z M78.2,233.4c-0.2,0-0.5-0.1-0.6-0.5l-0.1-0.5c-0.1-0.6-0.2-1.3-0.4-1.9 c0-0.4,0.1-0.6,0.5-0.7s0.6,0.1,0.7,0.5c0.1,0.6,0.2,1.2,0.4,1.8l0.1,0.5c0.1,0.4-0.1,0.6-0.4,0.7L78.2,233.4z M141.3,223.6 c-0.4,0-0.6-0.2-0.6-0.6c-0.1-1.9-0.4-4-0.8-5.9c-0.8-3.4-2.2-6.7-4.1-9.6c-0.1-0.2-0.1-0.6,0.2-0.8c0.2-0.1,0.6-0.1,0.8,0.1 c3.1,4.8,4.8,10.3,5.2,16C141.9,223.3,141.7,223.6,141.3,223.6L141.3,223.6L141.3,223.6z M79.4,213.4c-0.1,0-0.1,0-0.2,0 c-0.4-0.1-0.5-0.5-0.4-0.7l0,0c0.7-1.9,1.7-3.7,2.8-5.4c0.1-0.2,0.5-0.4,0.8-0.2c0.2,0.1,0.4,0.5,0.2,0.8l0,0 c-1.1,1.7-1.9,3.4-2.7,5.3C79.9,213.2,79.7,213.4,79.4,213.4L79.4,213.4z M84.3,205c-0.1,0-0.2,0-0.4-0.1c-0.2-0.2-0.2-0.6-0.1-0.8 c3.9-4.8,9.1-8.3,15-10.4c0.4-0.1,0.6,0.1,0.7,0.4c0.1,0.4-0.1,0.6-0.4,0.7c-5.7,1.8-10.8,5.3-14.5,9.9 C84.6,204.9,84.5,205,84.3,205L84.3,205z M134,205c-0.1,0-0.4-0.1-0.5-0.2c-1.2-1.6-2.7-2.9-4.1-4.2c-0.2-0.2-0.2-0.6-0.1-0.8l0,0 c0.2-0.2,0.6-0.2,0.8-0.1l0,0c1.6,1.3,3,2.8,4.4,4.4c0.2,0.2,0.1,0.6-0.1,0.8C134.3,204.9,134.2,204.9,134,205L134,205z  M113.3,193.5L113.3,193.5c-0.8-0.1-1.7-0.1-2.5-0.2c-0.4,0-0.6-0.4-0.6-0.6c0-0.4,0.4-0.6,0.6-0.6l0,0c0.8,0,1.7,0.1,2.4,0.2 c0.4,0,0.6,0.4,0.6,0.6C113.8,193.2,113.6,193.5,113.3,193.5L113.3,193.5L113.3,193.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 109.3,
    cy: 224.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 109.3,
    cy: 224.7,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.1,121.3c-0.4,0-0.6-0.2-0.7-0.5c0-0.4,0.2-0.6,0.5-0.7c0.7-0.2,1.6-0.5,2.3-0.7c0.2-0.1,0.6,0,0.8,0.2 c0.1,0.2,0,0.6-0.2,0.8h-0.1C87.9,120.8,87,121.1,86.1,121.3L86.1,121.3z M68.2,120.7h-0.2c-1.9-0.6-3.9-1.5-5.7-2.4 c-0.2-0.1-0.4-0.5-0.2-0.8c0.1-0.2,0.5-0.4,0.8-0.2c1.7,1,3.5,1.7,5.4,2.4c0.4,0.1,0.5,0.5,0.4,0.7l0,0 C68.7,120.6,68.4,120.7,68.2,120.7z M59.6,116.5c-0.1,0-0.2,0-0.4-0.1c-5.1-3.6-9.1-8.5-11.4-14.3c-0.1-0.4,0-0.7,0.4-0.8 c0.4-0.1,0.7,0,0.8,0.4l0,0c2.3,5.6,6,10.3,11,13.7c0.2,0.2,0.4,0.6,0.1,0.8C59.9,116.4,59.8,116.5,59.6,116.5z M98.9,114.7 c-0.4,0-0.6-0.4-0.6-0.6c0-0.1,0.1-0.4,0.2-0.4c4.6-3.9,7.9-8.9,9.7-14.6c0.1-0.4,0.5-0.5,0.7-0.5c0.4,0.1,0.5,0.5,0.5,0.7 c-1.8,5.9-5.3,11.2-10,15.2C99.3,114.7,99,114.7,98.9,114.7z M109.7,96.2L109.7,96.2c-0.5-0.1-0.6-0.4-0.6-0.7 c0.4-1.9,0.6-3.9,0.6-5.9c0-3.5-0.6-7-1.7-10.3c-0.1-0.4,0-0.6,0.4-0.8c0.4-0.1,0.6,0.1,0.7,0.4c1.2,3.4,1.8,7,1.8,10.6 c0,2.1-0.2,4.1-0.6,6.2C110.1,95.9,109.9,96.2,109.7,96.2L109.7,96.2z M46,90.7c-0.4,0-0.6-0.2-0.6-0.6l0,0v-0.5c0-0.6,0-1.3,0-1.9 c0-0.4,0.4-0.6,0.6-0.6c0.4,0,0.6,0.2,0.6,0.6l0,0c0,0.6,0,1.2,0,1.9v0.5C46.6,90.4,46.3,90.7,46,90.7z M107.1,76.3 c-0.2,0-0.5-0.1-0.5-0.4c-0.8-1.8-1.8-3.5-3-5.1c-0.2-0.2-0.1-0.6,0.1-0.8l0,0c0.2-0.2,0.6-0.1,0.8,0.1l0,0 c1.2,1.7,2.3,3.4,3.1,5.3c0.1,0.2,0,0.6-0.2,0.8l0,0C107.2,76.3,107.1,76.3,107.1,76.3L107.1,76.3z M52.1,71.4 c-0.1,0-0.2,0-0.4-0.1c-0.2-0.2-0.4-0.6-0.1-0.8l0,0c1.2-1.7,2.5-3.3,4-4.6c0.2-0.2,0.6-0.4,0.8-0.1c0.2,0.2,0.4,0.6,0.1,0.8 l-0.1,0.1c-1.5,1.3-2.7,2.9-3.9,4.5C52.4,71.4,52.2,71.5,52.1,71.4z M58.7,64.5c-0.4,0-0.6-0.2-0.6-0.6c0-0.2,0.1-0.4,0.2-0.5 c5-3.7,10.9-6,17.1-6.4c0.4,0,0.6,0.2,0.6,0.6l0,0c0,0.4-0.2,0.6-0.6,0.6c-5.9,0.5-11.6,2.7-16.4,6.2 C59.1,64.5,58.9,64.5,58.7,64.5z M89.7,60.3c-0.1,0-0.1,0-0.2,0c-0.7-0.2-1.5-0.6-2.2-0.8c-0.4-0.1-0.5-0.5-0.4-0.7l0,0 c0.1-0.4,0.4-0.5,0.7-0.4l0,0c0.7,0.2,1.6,0.5,2.3,0.8c0.4,0.1,0.5,0.5,0.4,0.7C90.2,60.1,89.9,60.3,89.7,60.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 78.1,
    cy: 89.6,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 78.1,
    cy: 99.6,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.2,228.5h-3.6c-0.1,0-0.2-0.1-0.2-0.2l-0.1-1.7c-1.1-0.2-2.1-0.6-3-1.2l-1.3,1.1c-0.1,0.1-0.2,0.1-0.4,0 l-2.5-2.5c-0.1-0.1-0.1-0.2,0-0.4l1.1-1.2c-0.6-1-1-1.9-1.2-3l-1.6-0.1c-0.1,0-0.2-0.1-0.2-0.2v-3.6c0-0.1,0.1-0.2,0.2-0.2l1.6-0.1 c0.2-1.1,0.6-2.1,1.2-3l-1.1-1.3c-0.1-0.1-0.1-0.2,0-0.4l2.5-2.5c0.1-0.1,0.2-0.1,0.4,0l1.3,1.1c1-0.6,1.9-1,3-1.2l0.1-1.7 c0-0.1,0.1-0.2,0.2-0.2h3.6c0.1,0,0.2,0.1,0.2,0.2l0.1,1.7c1.1,0.2,2.1,0.6,3,1.2l1.3-1.1c0.1-0.1,0.2-0.1,0.4,0l2.5,2.5 c0.1,0.1,0.1,0.2,0,0.4l-1.1,1.3c0.6,1,1,1.9,1.2,3l1.7,0.1c0.1,0,0.2,0.1,0.2,0.2v3.6c0,0.1-0.1,0.2-0.2,0.2l-1.7,0.1 c-0.2,1.1-0.6,2.1-1.2,3l1.1,1.2c0.1,0.1,0.1,0.2,0,0.4l-2.5,2.5c-0.1,0.1-0.2,0.1-0.4,0l-1.3-1.1c-1,0.6-1.9,1-3,1.2l-0.1,1.7 C119.4,228.4,119.3,228.5,119.2,228.5z M115.8,227.9h3l0.1-1.6c0-0.1,0.1-0.2,0.2-0.2c1.2-0.2,2.3-0.7,3.3-1.3 c0.1-0.1,0.2-0.1,0.4,0l1.2,1l2.2-2.2l-1-1.2c-0.1-0.1-0.1-0.2,0-0.4c0.6-1,1.1-2.1,1.3-3.3c0-0.1,0.1-0.2,0.2-0.2l1.6-0.1v-3 l-1.6-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.2-1.2-0.7-2.3-1.3-3.3c-0.1-0.1-0.1-0.2,0-0.4l1-1.2l-2.2-2.2l-1.2,1c-0.1,0.1-0.2,0.1-0.4,0 c-1-0.6-2.1-1.1-3.3-1.3c-0.1,0-0.2-0.1-0.2-0.2l-0.1-1.6h-3l-0.1,1.6c0,0.1-0.1,0.2-0.2,0.2c-1.1,0.2-2.3,0.7-3.3,1.3 c-0.1,0.1-0.2,0.1-0.4,0l-1.2-1l-2.2,2.2l1,1.2c0.1,0.1,0.1,0.2,0,0.4c-0.6,1-1.1,2.1-1.3,3.3c0,0.1-0.1,0.2-0.2,0.2l-1.6,0.1v3 l1.6,0.1c0.1,0,0.2,0.1,0.2,0.2c0.2,1.2,0.7,2.3,1.3,3.3c0.1,0.1,0.1,0.2,0,0.4l-1,1.2l2.2,2.2l1.2-1c0.1-0.1,0.2-0.1,0.4,0 c1,0.6,2.1,1.1,3.3,1.3c0.1,0,0.2,0.1,0.2,0.2L115.8,227.9z M117.4,222c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2 c2.9,0,5.2,2.3,5.2,5.2l0,0C122.5,219.7,120.2,222,117.4,222L117.4,222z M117.4,212.3c-2.5,0-4.6,2.1-4.6,4.6 c0,2.5,2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6l0,0C122,214.3,119.9,212.3,117.4,212.3L117.4,212.3L117.4,212.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M108.2,244.3h-2.8c-0.1,0-0.2-0.1-0.2-0.2l-0.1-1.2c-0.8-0.2-1.6-0.5-2.3-1l-1,0.8c-0.1,0.1-0.2,0.1-0.4,0 l-2.1-2.1c-0.1-0.1-0.1-0.2,0-0.4l0.8-1c-0.5-0.7-0.7-1.5-1-2.3l-1.2-0.1c-0.1,0-0.2-0.1-0.2-0.2v-2.8c0-0.1,0.1-0.2,0.2-0.2 l1.2-0.1c0.2-0.8,0.5-1.6,1-2.3l-0.8-1c-0.1-0.1-0.1-0.2,0-0.4l2.1-1.9c0.1-0.1,0.2-0.1,0.4,0l1,0.8c0.7-0.5,1.5-0.7,2.3-1l0.1-1.2 c0-0.1,0.1-0.2,0.2-0.2h2.9c0.1,0,0.2,0.1,0.2,0.2l0.1,1.2c0.8,0.2,1.6,0.5,2.3,1l1-0.8c0.1-0.1,0.2-0.1,0.4,0l1.9,1.9 c0.1,0.1,0.1,0.2,0,0.4l-0.8,1c0.5,0.7,0.7,1.5,1,2.3l1.2,0.1c0.1,0,0.2,0.1,0.2,0.2v2.8c0,0.1-0.1,0.2-0.2,0.2l-1.2,0.1 c-0.2,0.8-0.5,1.6-1,2.3l0.8,1c0.1,0.1,0.1,0.2,0,0.4l-1.9,2.1c-0.1,0.1-0.2,0.1-0.4,0l-1-0.8c-0.7,0.5-1.5,0.7-2.3,1l-0.1,1.2 C108.4,244.1,108.3,244.2,108.2,244.3z M105.7,243.7h2.3l0.1-1.2c0-0.1,0.1-0.2,0.2-0.2c0.8-0.1,1.7-0.5,2.5-1.1 c0.1-0.1,0.2-0.1,0.4,0l1,0.7l1.6-1.6l-0.7-1c-0.1-0.1-0.1-0.2,0-0.4c0.5-0.7,0.8-1.6,1.1-2.5c0-0.1,0.1-0.2,0.2-0.2l1.2-0.1v-2.3 l-1.2-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.2-0.8-0.5-1.7-1.1-2.5c-0.1-0.1-0.1-0.2,0-0.4l0.7-1l-1.6-1.6l-1,0.7c-0.1,0.1-0.2,0.1-0.4,0 c-0.7-0.5-1.6-0.8-2.5-1.1c-0.1,0-0.2-0.1-0.2-0.2l-0.1-1.2h-2.3l-0.1,1.2c0,0.1-0.1,0.2-0.2,0.2c-0.8,0.2-1.7,0.5-2.5,1.1 c-0.1,0.1-0.2,0.1-0.4,0l-1-0.7l-1.6,1.6l0.7,1c0.1,0.1,0.1,0.2,0,0.4c-0.5,0.7-0.8,1.6-1.1,2.5c0,0.1-0.1,0.2-0.2,0.2l-1.2,0.1 v2.3l1.2,0.1c0.1,0,0.2,0.1,0.2,0.2c0.2,0.8,0.5,1.7,1.1,2.5c0.1,0.1,0.1,0.2,0,0.4l-0.7,1l1.6,1.6l1-0.7c0.1-0.1,0.2-0.1,0.4,0 c0.7,0.5,1.6,0.8,2.5,1.1c0.1,0,0.2,0.1,0.2,0.2L105.7,243.7z M106.8,239.2c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1 c2.3,0,4.1,1.8,4.1,4.1l0,0C111,237.3,109,239.2,106.8,239.2L106.8,239.2L106.8,239.2z M106.8,231.5c-1.9,0-3.5,1.6-3.5,3.5 s1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5l0,0C110.3,233.1,108.7,231.5,106.8,231.5L106.8,231.5L106.8,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M99.7,225.3l0.8,1l1.9-1.3l-0.6-1.1c0.6-0.6,1-1.2,1.3-1.9l1.2,0.1l0.5-2.3l-1.2-0.4c0-0.8-0.2-1.6-0.5-2.3 l1-0.7l-1.3-1.9l-1.1,0.6c-0.6-0.6-1.2-1-1.9-1.3l0.1-1.2l-2.3-0.5l-0.4,1.2c-0.8,0-1.6,0.2-2.3,0.5l-0.8-1l-1.9,1.3l0.6,1.1 c-0.6,0.6-1,1.2-1.3,1.9l-1.2-0.1l-0.5,2.3l1.2,0.4c0,0.8,0.2,1.6,0.5,2.3l-1,0.7l1.3,1.9L93,224c0.6,0.6,1.2,1,2.1,1.3l-0.1,1.2 l2.3,0.5l0.4-1.2C98.2,225.8,99,225.7,99.7,225.3z M94.2,218.9c0.4-1.7,2.1-2.9,3.7-2.5c1.7,0.4,2.9,2.1,2.5,3.7 c-0.4,1.7-2.1,2.9-3.7,2.5l0,0C94.9,222.3,93.8,220.6,94.2,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M79.8,96.9c1.1,1.1,2.9,1,4-0.2c1.1-1.1,1-2.9-0.2-4c-1.1-1.1-2.9-1-4,0.2c-0.2,0.4-0.5,0.7-0.6,1.1l-1.1-4 l-2.4,0.7l0.2,0.2c0.2,0.4,0.5,0.7,0.6,1.2c0.4,1.9-1,3.7-2.9,4.1c-1.7,0.2-3.3-0.6-3.9-2.2c-0.1-0.5-0.1-0.8-0.1-1.3v-0.4 l-2.7,0.7l1,3.1l2.1,7l0,0c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0.1l0.1,0.1h0.1l0.2,0.1h0.1c0.1,0,0.2,0,0.4,0l5.1-1.5l5.2-1.5 L79.8,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M85.9,85.3c-0.4-1.5-1.9-2.3-3.4-1.9c-0.2,0.1-0.5,0.1-0.7,0.2C81,84.1,80.5,85,80.5,86c0,1.2,0.8,2.3,2.1,2.7 l-4,1.1l0.7,2.4l0.2-0.2c0.4-0.2,0.7-0.5,1.2-0.6c1.8-0.6,3.9,0.5,4.4,2.3c0.6,1.8-0.5,3.9-2.3,4.4h-0.1c-0.5,0.1-0.8,0.1-1.3,0.1 H81l0.7,2.7l10.2-2.9c0.5-0.1,0.7-0.6,0.6-1.1l0,0l-1.9-6.5l-1.1-3.6l-4.2,1.2C86.1,87.2,86.3,86.3,85.9,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M63.6,82.3L63.6,82.3l2.9,10.2l4.2-1.2c-1.1,1.1-1,2.9,0.1,3.9c1,0.8,2.3,1,3.4,0.4c1.3-0.8,1.7-2.5,1-3.9 c-0.4-0.6-1-1-1.6-1.2l4-1.1l-0.7-2.4l-0.2,0.2c-0.4,0.2-0.7,0.5-1.2,0.6c-1.8,0.6-3.9-0.5-4.4-2.3c-0.6-1.8,0.5-3.9,2.3-4.4h0.1 c0.5-0.1,0.8-0.1,1.3-0.1h0.4l-0.7-2.7l-10.2,2.9C63.7,81.2,63.5,81.7,63.6,82.3L63.6,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M93.7,96.5l-6-21.2c-0.1-0.6-0.5-1-1-1.3c-0.4-0.1-0.7-0.2-1.1-0.2c-0.2,0-0.4,0-0.6,0.1l-21.2,6 c-1.1,0.4-1.8,1.5-1.5,2.7l6,21.2c0.2,1,1.1,1.6,2.1,1.6c0.2,0,0.4,0,0.6-0.1l21.2-6C93.3,98.8,94.1,97.7,93.7,96.5z M70.7,104 c-0.1,0-0.2,0-0.4,0h-0.1l-0.2-0.1h-0.1l-0.1-0.1c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.2l0,0l-2.1-7l-1-3.1l2.7-0.7v0.4 c0,0.5,0,0.8,0.1,1.3c0.6,1.8,2.5,2.9,4.4,2.3c1.8-0.5,2.9-2.4,2.4-4.2c-0.1-0.5-0.4-0.8-0.6-1.2l-0.2-0.2l2.4-0.7l1.1,4 c0.5-1.5,1.9-2.3,3.5-1.8c1.5,0.5,2.3,1.9,1.8,3.5c-0.5,1.6-1.9,2.3-3.5,1.8c-0.4-0.1-0.7-0.4-1.1-0.6l1.2,4.2l-5.2,1.5L70.7,104z  M90.7,90.4l1.9,6.5l0,0c0.1,0.5-0.1,1-0.6,1.1l-10.2,2.9l-0.7-2.7h0.4c0.5,0,0.8,0,1.3-0.1c1.8-0.5,3-2.4,2.5-4.4 c-0.5-1.8-2.4-3-4.4-2.5h-0.1c-0.5,0.1-0.8,0.4-1.2,0.6l-0.2,0.2l-0.7-2.4l4-1.1c-1.2-0.4-1.9-1.5-2.1-2.7c0-1,0.5-1.9,1.3-2.4 c1.3-0.8,3-0.4,3.9,1c0.6,1.1,0.5,2.3-0.2,3.3l4.2-1.2L90.7,90.4z M75.2,80.9h-0.4c-0.5,0-0.8,0-1.3,0.1c-1.8,0.5-2.9,2.4-2.4,4.4 c0.5,1.9,2.4,2.9,4.4,2.4c0.5-0.1,0.8-0.4,1.2-0.6l0.2-0.2l0.7,2.4l-4,1.1c1.5,0.5,2.3,1.9,1.9,3.5c-0.2,0.6-0.6,1.2-1.2,1.6 c-1.3,0.8-3,0.4-3.9-0.8c-0.6-1.1-0.5-2.4,0.4-3.4l-4.2,1.2l-2.9-10.2l0,0c-0.1-0.5,0.1-1,0.6-1.1l10.2-2.9L75.2,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.1,270.8c-0.4,0-0.6-0.2-0.6-0.6c0-0.4,0.2-0.6,0.6-0.6c0.8-0.1,1.6-0.2,2.4-0.4c0.4,0,0.6,0.1,0.7,0.5 c0.1,0.4-0.1,0.6-0.5,0.7C379.8,270.6,379,270.7,378.1,270.8L378.1,270.8z M360.2,269c-0.1,0-0.1,0-0.2,0c-0.6-0.2-1.3-0.5-1.9-0.7 c-1.2-0.5-2.4-1.1-3.6-1.7c-0.2-0.1-0.4-0.5-0.2-0.8c0.1-0.2,0.5-0.4,0.8-0.2c1.1,0.6,2.3,1.2,3.5,1.7c0.6,0.2,1.3,0.5,1.9,0.7 c0.4,0,0.6,0.4,0.5,0.7C361,268.9,360.6,269.1,360.2,269L360.2,269z M391.9,266.5c-0.2,0-0.5-0.1-0.5-0.4c-0.1-0.2,0-0.6,0.2-0.8 c5.3-2.8,9.8-6.8,13.3-11.6c0.2-0.2,0.6-0.4,0.8-0.1l0,0c0.2,0.2,0.4,0.6,0.1,0.8c-3.6,5-8.3,9.1-13.8,12 C392,266.5,391.9,266.5,391.9,266.5L391.9,266.5z M351.5,264.8c-0.1,0-0.2,0-0.4-0.1c-5.2-3.4-9.6-7.9-12.7-13.1 c-0.1-0.2-0.1-0.6,0.2-0.8c0.2-0.1,0.6-0.1,0.8,0.2l0,0c3.1,5.1,7.3,9.4,12.3,12.7c0.2,0.1,0.4,0.6,0.1,0.8 C352,264.6,351.8,264.8,351.5,264.8z M407.4,251.6c-0.1,0-0.2,0-0.4-0.1c-0.2-0.1-0.4-0.5-0.2-0.8l0,0c1-1.7,1.9-3.5,2.7-5.3 c0.1-0.4,0.5-0.5,0.7-0.4c0.2,0.1,0.5,0.5,0.4,0.7l0,0c-0.7,1.9-1.7,3.7-2.7,5.6C407.9,251.5,407.6,251.6,407.4,251.6L407.4,251.6z  M410.9,244h-0.2c-0.4-0.1-0.5-0.5-0.4-0.7c0.6-1.9,1.1-3.7,1.5-5.8c0-0.4,0.4-0.6,0.7-0.5c0.4,0,0.6,0.4,0.5,0.7l0,0 c-0.4,2.1-0.8,4-1.5,5.9C411.4,243.8,411.2,244,410.9,244L410.9,244z M334.5,240.7c-0.2,0-0.5-0.2-0.6-0.5 c-0.2-0.8-0.4-1.6-0.5-2.4c0-0.4,0.1-0.6,0.5-0.7c0.4,0,0.6,0.1,0.7,0.5c0.1,0.7,0.4,1.6,0.5,2.3c0.1,0.4-0.1,0.6-0.5,0.7 L334.5,240.7z M334.8,220.4h-0.1c-0.4-0.1-0.5-0.5-0.5-0.7c0.4-1.3,0.8-2.7,1.3-4c0.2-0.6,0.5-1.2,0.7-1.7c0.1-0.2,0.5-0.5,0.7-0.2 l0,0c0.4,0.1,0.5,0.5,0.2,0.8c-0.2,0.6-0.5,1.1-0.7,1.7c-0.5,1.3-1,2.5-1.3,3.9C335.3,220.3,335.2,220.4,334.8,220.4L334.8,220.4z  M411.4,220.1c-0.2,0-0.5-0.1-0.6-0.5c-0.2-0.7-0.5-1.6-0.7-2.3c-0.1-0.4,0.1-0.6,0.5-0.7c0.2-0.1,0.6,0.1,0.7,0.4 c0.2,0.7,0.5,1.6,0.7,2.3c0.1,0.4-0.1,0.6-0.4,0.7L411.4,220.1z M338.6,211.5c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.4-0.5-0.2-0.8 c3-5.3,7.3-9.9,12.5-13.4c0.2-0.2,0.6-0.1,0.8,0.1c0.2,0.2,0.1,0.6-0.1,0.8l0,0c-5,3.4-9.1,7.7-12.1,12.9 C339,211.4,338.8,211.5,338.6,211.5z M405,207.3c-0.2,0-0.4-0.1-0.5-0.2c-3.6-4.8-8.2-8.7-13.5-11.4c-0.2-0.1-0.4-0.5-0.2-0.8 c0.1-0.2,0.5-0.4,0.7-0.2c5.6,2.8,10.3,6.8,14,11.7c0.2,0.2,0.1,0.6-0.1,0.8C405.2,207.3,405.1,207.3,405,207.3L405,207.3z  M387.8,194.4c-0.1,0-0.1,0-0.2,0c-1.8-0.7-3.7-1.3-5.7-1.8c-0.4-0.1-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5c1.9,0.5,4,1.1,5.8,1.8 c0.4,0.1,0.5,0.5,0.4,0.7l0,0C388.3,194.1,388.1,194.3,387.8,194.4L387.8,194.4z M361.7,193.2c-0.4,0-0.6-0.2-0.7-0.5 c-0.1-0.2,0.2-0.6,0.5-0.7c0.7-0.2,1.6-0.5,2.4-0.6c0.4-0.1,0.7,0.1,0.7,0.5c0.1,0.4-0.1,0.7-0.5,0.7c-0.7,0.1-1.6,0.4-2.3,0.6 H361.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 372.6,
    cy: 227.8,
    r: 32.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 372.6,
    cy: 227.8,
    r: 32.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M373.2,247.5c-9.3,0-16.9-7.5-16.9-16.9c0-9.3,7.5-16.9,16.9-16.9s16.9,7.5,16.9,16.9 c0,8.7-6.5,16.1-15.2,16.9C374.3,247.3,373.7,247.5,373.2,247.5z M373.2,216.4c-7.9,0-14.3,6.4-14.3,14.3s6.4,14.3,14.3,14.3 c4.2,0,8.3-1.9,11-5.2l0,0c5.1-6,4.2-15.1-1.8-20.1C379.7,217.6,376.6,216.4,373.2,216.4L373.2,216.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M373.2,241.1c-2.4,0-4.7-0.8-6.5-2.4l0,0c-4.5-3.6-5.1-10.2-1.5-14.6c3.6-4.5,10.2-5.1,14.6-1.5l0,0 c4.5,3.6,5.1,10.2,1.5,14.5c-1.7,2.2-4.2,3.5-7,3.7C373.8,241.1,373.5,241.1,373.2,241.1z M368.1,236.8c3.4,2.8,8.3,2.3,11.1-1.1 c2.8-3.4,2.3-8.3-1.1-11.1s-8.3-2.3-11.1,1.1C364.2,229,364.7,233.9,368.1,236.8L368.1,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373.2,234.6c-1,0-1.8-0.4-2.5-1c-0.8-0.7-1.3-1.7-1.5-2.7c-0.2-2.2,1.5-4.1,3.6-4.4l0,0 c2.2-0.2,4.1,1.5,4.4,3.6c0.1,1.1-0.2,2.1-0.8,2.9c-0.7,0.8-1.7,1.3-2.7,1.5L373.2,234.6z M373.2,229.1L373.2,229.1 c-1,0.1-1.6,0.8-1.5,1.7c0,0.4,0.2,0.8,0.6,1.1l0,0c0.7,0.6,1.7,0.5,2.2-0.2l0,0c0.2-0.4,0.4-0.7,0.4-1.2c0-0.4-0.2-0.8-0.6-1.1 C373.9,229.2,373.5,229.1,373.2,229.1L373.2,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373.2,231.3c-0.1,0-0.2,0-0.4-0.1L356,217.2c-0.2-0.2-0.2-0.6-0.1-0.8l0,0c0.2-0.2,0.6-0.2,0.8-0.1l16.8,13.8 c0.2,0.2,0.2,0.6,0.1,0.8C373.5,231.3,373.3,231.3,373.2,231.3L373.2,231.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.4,220.4c-0.4,0-0.6-0.2-0.6-0.6s0.2-0.6,0.6-0.6l3.5-0.4l-0.4-3.5c0-0.4,0.2-0.6,0.5-0.6l0,0 c0.4,0,0.6,0.2,0.6,0.5l0,0l0.4,4.1c0,0.4-0.2,0.6-0.5,0.6l0,0L355.4,220.4L355.4,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.6,218.9c-0.4,0-0.6-0.2-0.6-0.6s0.2-0.6,0.6-0.6l3.5-0.4l-0.4-3.5c0-0.4,0.2-0.6,0.6-0.6s0.6,0.2,0.6,0.6 l0.4,4.1c0,0.4-0.2,0.6-0.5,0.6l0,0l-4.1,0.4H353.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.8,217.5c-0.4,0-0.6-0.2-0.6-0.5c0-0.4,0.2-0.6,0.6-0.7l3.5-0.4l-0.4-3.5c0-0.4,0.2-0.6,0.5-0.6l0,0 c0.4,0,0.6,0.2,0.6,0.5l0,0l0.4,4.1c0,0.4-0.2,0.6-0.5,0.6l0,0L351.8,217.5L351.8,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180,105.2L180,105.2l-70.3-10.5c-0.4,0-0.6-0.4-0.5-0.6l0,0c0-0.4,0.4-0.6,0.7-0.5l70.3,10.5 c0.4,0,0.6,0.4,0.5,0.7l0,0C180.6,105,180.4,105.2,180,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.5,203.2c-0.4,0-0.6-0.2-0.6-0.6c0-0.1,0.1-0.4,0.2-0.5l60.3-57.6c0.2-0.2,0.6-0.2,0.8,0l0,0 c0.2,0.2,0.2,0.6,0,0.8l0,0L132.9,203C132.8,203.1,132.6,203.2,132.5,203.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.3,206.1c-0.1,0-0.2,0-0.4-0.1l-77.3-63.1c-0.2-0.2-0.4-0.6-0.1-0.8c0.2-0.2,0.6-0.4,0.8-0.1 c0,0,0.1,0,0.1,0.1l77.3,63.1c0.2,0.2,0.2,0.6,0.1,0.8C342.7,206,342.5,206.1,342.3,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.4,99.8c-0.4,0-0.6-0.2-0.7-0.5c-0.1-0.2,0.2-0.6,0.5-0.7l0,0l64.6-17.4c0.4-0.1,0.7,0.1,0.7,0.5 c0.1,0.4-0.1,0.7-0.5,0.7L274.4,99.8L274.4,99.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Podium--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "454.1,388.7 415.5,388.7 410.2,388.7 410.2,361.3 393.3,361.3 354.7,361.3 337.7,361.3 337.7,408.6  332.4,408.6 294,408.6 277,408.6 277,454.4 294,454.4 332.4,454.4 337.7,454.4 349.4,454.4 354.7,454.4 393.3,454.4 398.6,454.4  410.2,454.4 415.5,454.4 454.1,454.4 471,454.4 471,388.7  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 408.6,
    className: "st12",
    width: 55.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.7,
    y: 361.3,
    className: "st12",
    width: 55.5,
    height: 93.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.6,
    y: 388.7,
    className: "st12",
    width: 55.5,
    height: 65.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M367.3,375.3V396h-3.9v-17.5H359v-3.1H367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M432.9,422v3.3h-15.2v-2.5l8.2-7.7c2.1-1.9,2.4-3.1,2.4-4.2c0-1.9-1.3-3-3.9-3c-1.8-0.1-3.6,0.7-4.8,2.2 l-2.7-2.1c1.9-2.3,4.8-3.6,7.9-3.4c4.5,0,7.4,2.3,7.4,5.9c0,2.1-0.6,3.9-3.4,6.5l-5.6,5.2h9.7V422z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M312.1,435.5c0,3.5-2.7,6.5-8.2,6.5c-2.8,0-5.4-0.8-7.7-2.4l1.7-3c1.7,1.3,3.9,2.1,6,2.1 c2.8,0,4.4-1.2,4.4-3.1c0-1.9-1.3-3-4.5-3h-1.9v-2.7l4.7-5.6h-9.4v-3.1h14v2.5l-5,5.9C310.2,430.1,312.1,432.5,312.1,435.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "174.7,443.3 162.5,454.3 152,453.1 166.1,437.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "348.4,443.5 361.9,452.8 372.2,450.3 356.2,436.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M158.2,441.8l9.7,9.3c0,0,70-55.9,71.1-65.2c1.1-9.3,0-59.1,0-59.1s9.3,10.9,23.8,27.2 c23.2,26.1,59.6,65.9,91.6,95.9l11.2-7.7C284.7,341.3,259,287.3,259,287.3l-3.4-25.4l-46.4-4.2c0,0-11.1,29.3-8.1,51 c3,21.8,14.5,62.2,13.3,70.3C213.2,387,158.2,441.8,158.2,441.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M163.4,452.3h-11.6c-0.4,0-0.7,0.2-0.8,0.6l-1.9,8.5c-0.1,0.7,0.4,1.5,1.1,1.7l0,0c0.1,0,0.2,0,0.2,0 c3.7,0,6.5-0.2,11.2-0.2c2.9,0,11.6,0.2,15.7,0.2c4.1,0,4.5-4,2.9-4.4c-7.4-1.6-12.9-3.9-15.2-5.9 C164.6,452.5,164,452.3,163.4,452.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M370.2,447.7l-10.4,5c-0.4,0.1-0.5,0.6-0.5,1l1.9,8.5c0.1,0.7,1,1.2,1.7,1.1l0,0l0.2-0.1 c3.4-1.7,5.8-3,10-5.1c2.7-1.2,10.6-4.7,14.3-6.4c3.6-1.7,2.4-5.6,0.7-5.1c-7.4,1.7-13.3,2.1-16.3,1.1 C371.4,447.4,370.8,447.5,370.2,447.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M237.1,304.7l1.9,22c0,0,9.3,10.9,23.8,27.2c-15.4-24.8-19.5-41.8-19.5-41.8c5-6.7,5.6-17.4,5.6-17.4 L237.1,304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M213.8,145.9l3.4-3.9l2.4,0.1c0.8,0,8.9-8.3,8.9-8.7c0-0.4-4.7-3.6-5.9-3.7s-6.7,6-6.7,6l-0.1,2.4l-5.1,4.1 L213.8,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M249,151.6l-2.9-2.5c0,0-4.4,1.2-4.7-0.4c-0.1-2.3-0.1-4.5,0-6.8l1-9.2c0,0,3.7-1.1,5.3,0.4 s0.1,12.2,0.1,12.2l7.1,6.8L249,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M255.4,198.6c4.8-5,11.2-22,11-26.7c-0.2-4.7-19.1-20.6-19.1-20.6l2.5-4.6c0,0,23.7,14.5,26.5,20.6 c2.8,6-6.3,42.6-19,52l-7-9.8L255.4,198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M255.4,198.6c4.8-5,11.2-22,11-26.7c-0.2-4.7-19.1-20.6-19.1-20.6l2.5-4.6c0,0,23.7,14.5,26.5,20.6 c2.8,6-6.3,42.6-19,52l-7-9.8L255.4,198.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.1,263.8 206.3,263.8 206.3,269.6 255.7,269  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 261.1,
    className: "st14",
    width: 1.7,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 261.1,
    className: "st14",
    width: 1.7,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.9,
    y: 262.7,
    className: "st12",
    width: 9.1,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M208,100.9c-0.5-1.6-1.6-2.8-3-3.5c-1.3-0.6-2.8-0.8-4.2-0.5c-1.5,0.2-2.8,1-3.7,1.9 c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.2-0.4,0.6-0.5,1l-0.2,0.5l-0.1,0.5l-0.2,1c-0.6,2.5-0.1,5.2,1.2,7.5c1.3,2.1,3.1,3.7,5.3,5 c2.1,1.1,4.4,1.8,6.7,2.2c1.1,0.1,2.3,0.2,3.5,0.2c1.1,0,2.1,0,3.1,0.1c1,0.1,1.8,0.6,2.4,1.2c0.6,0.6,0.7,1.5,0.5,2.2 c-0.4,0.7-1.2,1-1.9,0.6c-0.6-0.2-0.8-1-0.6-1.6c0.1-0.2,0.4-0.5,0.6-0.6c-0.7,0-1.2,0.5-1.3,1.2c-0.1,0.7,0.1,1.5,0.7,1.9 c0.6,0.5,1.3,0.6,2.1,0.5s1.3-0.6,1.7-1.2c0.7-1.3,0.5-2.9-0.5-4c-0.8-1-2.1-1.7-3.3-1.9c-1.2-0.2-2.3-0.4-3.5-0.4 c-1.1,0-2.2-0.2-3.1-0.4c-2.1-0.4-4-1.1-5.8-2.2c-1.7-1-3.1-2.4-4.2-4.1c-1-1.7-1.2-3.7-0.7-5.7c0.5-2.1,2.7-3.4,4.7-2.8 c0,0,0,0,0.1,0c2.1,0.7,3.4,2.8,4,4.7L208,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M238.8,95.2c-0.1-1.6,0.5-3.1,1.6-4.4c1-1.1,2.3-1.7,3.7-2.1c1.5-0.2,2.9-0.1,4.2,0.5 c0.6,0.4,1.2,0.7,1.8,1.2l0.4,0.4l0.2,0.4l0.6,0.7c1.5,2.2,2.1,4.8,1.5,7.4c-0.5,2.4-1.6,4.7-3.1,6.5s-3.4,3.3-5.4,4.5 c-1,0.6-2.1,1.1-3.1,1.5c-1,0.4-1.9,0.7-2.9,1.2c-0.8,0.5-1.5,1.2-1.8,2.1c-0.4,0.7-0.2,1.6,0.4,2.2c0.6,0.5,1.5,0.5,2.1-0.1 c0.5-0.5,0.5-1.2,0-1.7c-0.2-0.2-0.5-0.4-0.8-0.4c0.6-0.2,1.3,0,1.7,0.6c0.4,0.6,0.5,1.5,0.1,2.1c-0.4,0.7-1.1,1.1-1.8,1.2 s-1.5-0.1-2.1-0.5c-1.1-1-1.6-2.5-1-3.9c0.5-1.2,1.3-2.3,2.4-3c1-0.6,2.1-1.2,3.1-1.6c1-0.5,1.9-1,2.8-1.5 c1.8-1.1,3.4-2.5,4.6-4.1c1.3-1.6,2.1-3.4,2.4-5.4c0.2-1.9-0.2-4-1.5-5.6c-1.2-1.8-3.7-2.2-5.4-1c0,0-0.1,0-0.1,0.1 c-1.7,1.3-2.1,3.9-2.1,5.8L238.8,95.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,100.9c-0.5-1.6-1.6-2.8-3-3.5c-1.3-0.6-2.8-0.8-4.2-0.5c-1.5,0.2-2.8,1-3.7,1.9c-0.2,0.2-0.5,0.5-0.7,0.8 c-0.2,0.2-0.4,0.6-0.5,1l-0.2,0.5l-0.1,0.5l-0.2,1c-0.6,2.5-0.1,5.2,1.2,7.5c1.3,2.1,3.1,3.7,5.3,5c2.1,1.1,4.4,1.8,6.7,2.2 c1.1,0.1,2.3,0.2,3.5,0.2c1.1,0,2.1,0,3.1,0.1c1,0.1,1.8,0.6,2.4,1.2c0.6,0.6,0.7,1.5,0.5,2.2c-0.4,0.7-1.2,1-1.9,0.6 c-0.6-0.2-0.8-1-0.6-1.6c0.1-0.2,0.4-0.5,0.6-0.6c-0.7,0-1.2,0.5-1.3,1.2c-0.1,0.7,0.1,1.5,0.7,1.9c0.6,0.5,1.3,0.6,2.1,0.5 s1.3-0.6,1.7-1.2c0.7-1.3,0.5-2.9-0.5-4c-0.8-1-2.1-1.7-3.3-1.9c-1.2-0.2-2.3-0.4-3.5-0.4c-1.1,0-2.2-0.2-3.1-0.4 c-2.1-0.4-4-1.1-5.8-2.2c-1.7-1-3.1-2.4-4.2-4.1c-1-1.7-1.2-3.7-0.7-5.7c0.5-2.1,2.7-3.4,4.7-2.8c0,0,0,0,0.1,0 c2.1,0.7,3.4,2.8,4,4.7L208,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.8,95.2c-0.1-1.6,0.5-3.1,1.6-4.4c1-1.1,2.3-1.7,3.7-2.1c1.5-0.2,2.9-0.1,4.2,0.5c0.6,0.4,1.2,0.7,1.8,1.2l0.4,0.4 l0.2,0.4l0.6,0.7c1.5,2.2,2.1,4.8,1.5,7.4c-0.5,2.4-1.6,4.7-3.1,6.5s-3.4,3.3-5.4,4.5c-1,0.6-2.1,1.1-3.1,1.5 c-1,0.4-1.9,0.7-2.9,1.2c-0.8,0.5-1.5,1.2-1.8,2.1c-0.4,0.7-0.2,1.6,0.4,2.2c0.6,0.5,1.5,0.5,2.1-0.1c0.5-0.5,0.5-1.2,0-1.7 c-0.2-0.2-0.5-0.4-0.8-0.4c0.6-0.2,1.3,0,1.7,0.6c0.4,0.6,0.5,1.5,0.1,2.1c-0.4,0.7-1.1,1.1-1.8,1.2s-1.5-0.1-2.1-0.5 c-1.1-1-1.6-2.5-1-3.9c0.5-1.2,1.3-2.3,2.4-3c1-0.6,2.1-1.2,3.1-1.6c1-0.5,1.9-1,2.8-1.5c1.8-1.1,3.4-2.5,4.6-4.1 c1.3-1.6,2.1-3.4,2.4-5.4c0.2-1.9-0.2-4-1.5-5.6c-1.2-1.8-3.7-2.2-5.4-1c0,0-0.1,0-0.1,0.1c-1.7,1.3-2.1,3.9-2.1,5.8L238.8,95.2z "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M221.9,119.8c-6.9-1.8-13.2-8.1-15.8-16.9l-1.2-4l36-6.8l0.2,4.2c0.6,9.2-2.9,17.3-8.7,21.5 c-1.6,1.1-2.3,3-1.9,5l1.3,8c0.4,1.9,2.1,3.4,4,3.3c1.7,0,3.4,0.6,4.7,1.7l1.6,1.3l-22.3,4.1l1-1.9c0.8-1.6,2.2-2.7,3.9-3.3 c1.8-0.7,2.9-2.7,2.5-4.5l-1.6-7.9C225.2,121.7,223.7,120.2,221.9,119.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "242.9,135 218.4,139.5 218.9,147.7 245.3,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "237.4,136 223.9,138.5 224.5,146.6 239.8,143.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.3,
    y: 139.6,
    transform: "matrix(0.9831 -0.1831 0.1831 0.9831 -21.9347 44.7526)",
    className: "st12",
    width: 8.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M231.3,117.1c-1.5,1.3-2.2,3.4-1.8,5.3l1.7,8.9c0.4,1.8,1,2.3,2.9,2.7c1.2,0.1,2.3,0.6,3.3,1.3l-3.7,0.7 c-0.4-0.2-0.8-0.4-1.3-0.5l-0.6-0.1c-0.7-0.1-1.3-0.8-1.6-1.6l-2.7-14.6c-0.2-1.1,0.1-2.2,0.8-2.9l0.7-0.8c3-3.4,4.7-8,4.6-12.6 l-0.2-8.5l5.4-1l-0.2,9.8C238.5,107.9,235.6,113.6,231.3,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M223.2,203.8c3.9,4.1,14.3,3.5,14.3,3.5s6.5-1.2,5.3-3.4c-3.7-1-5.4-2.8-6-5.1c-0.2-1.5-0.2-2.9,0-4.4 c0.1-0.8,0.2-1.6,0.5-2.4l-12-10.4C226.5,188,227.7,199.6,223.2,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M227.8,187.8c0,7.6,6,10.2,9.1,10.9c-0.2-1.5-0.2-2.9,0-4.4L227.8,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M243.4,167c0,0,2.7-6.2-5.4-10c-8.1-3.9-27.1,0.4-22.6,14.1C219.8,184.9,243.4,167,243.4,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M241.8,162.2c0,0,5.1,8.8,0.7,15.5c-4.4,6.7-12.6-14.4-12.6-14.4L241.8,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.6,192.7c0.4,0.2,0.7,0.6,1.1,0.8c4.1,2.8,9.6,2.5,13.3-0.6c2.4-1.9,4-4.8,4.5-7.9 c0.1-0.5,0.1-0.8,0.1-1.3c0-1,0-1.8-0.1-2.8c-0.6-7.9-4.5-17.9-12.6-19.5c-6.5-1.2-12.8,3-14,9.6c-0.4,1.8-0.2,3.7,0.2,5.4 C222.4,184.3,223.3,189.3,227.6,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M233.7,176.2c0.1,0.7,0.6,1.2,1.1,1.1c0.5-0.1,0.7-0.7,0.6-1.5c-0.1-0.7-0.6-1.2-1.1-1.1 C233.9,174.9,233.6,175.5,233.7,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M241.6,174.5c0.1,0.7,0.6,1.2,1.1,1.1c0.5-0.1,0.7-0.7,0.6-1.5c-0.1-0.7-0.6-1.2-1.1-1.1 S241.5,173.9,241.6,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M239.2,175.5c1.2,1.9,2.8,3.7,4.6,5.3c-0.8,0.8-2.1,1.3-3.3,1.3L239.2,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M230.7,174.2c0.1,0,0.2-0.1,0.4-0.2c0.5-1,1.3-1.7,2.3-1.9c0.2,0,0.4-0.2,0.4-0.5c0-0.2-0.2-0.4-0.5-0.4l0,0 l0,0c-1.3,0.2-2.4,1.2-3,2.4c-0.1,0.2,0,0.5,0.1,0.6l0,0l0,0C230.6,174.2,230.7,174.2,230.7,174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M244.4,171.2c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2-0.4,0.1-0.6l0,0c-0.8-1.1-2.1-1.7-3.4-1.7 c-0.2,0-0.4,0.2-0.4,0.5l0,0l0,0c0,0.2,0.2,0.4,0.5,0.4l0,0c1.1,0,2.1,0.5,2.7,1.3C244.1,171.2,244.3,171.2,244.4,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M223.3,182c-0.7,0.4,1.2,7.1,1.2,7.1s-3.7-1-6.8-6c-6-10.2-4.8-13.2-2.5-15.5c4.4-4.5,12.7-0.2,12.7-0.2 c-1.7,0-3.1,1.3-3.1,3.1c0,0.6,0.1,1.2,0.5,1.7c2.1,2.8,1.5,8.1-0.5,10.8C224.8,182.8,224.4,181.4,223.3,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M218,184.3c1.3,1.7,3.4,2.9,5.6,3.1c2.9,0.4,3.9-2.3,2.7-4.8c-1.1-2.2-3.9-5.2-6.5-4.4 c-1.9,0.6-3,2.7-2.4,4.6C217.3,183.5,217.7,184,218,184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M221.8,164.6c2.9,3.5,7.5,5.2,12,4.6c0,0-3.6-0.4-4.8-1.3c0,0,8.2,1.5,14.5-0.8s-2.5-10.3-6.3-10.2 C233.4,157,220,158.8,221.8,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M240.8,185.4c-0.6,0.8-1.2,1.7-1.7,2.5l-0.5-0.2c-2.3-0.8-3-2.1-3.1-3c-0.1-0.5,0-1,0.1-1.5 c0.1-0.2,0.2-0.5,0.4-0.7c1.2,1.2,2.5,2.1,4.1,2.7C240.4,185.3,240.8,185.4,240.8,185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M239.9,185.1l-0.5,0.7c-2.2-0.8-3.5-1.7-4-2.7c0.1-0.2,0.2-0.5,0.4-0.7C237,183.6,238.5,184.5,239.9,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M238.6,187.7c-2.3-0.8-3-2.1-3.1-3c0.8,0.4,1.6,0.8,2.3,1.5C238.1,186.5,238.3,187.1,238.6,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M255.7,265.4l-48.9-2.5c0.7-23.8-0.6-55.4-1.7-64.2l4.1-5.9c0,0,13.3,13.1,19.5,13.1 c9.3,0,18.5-2.5,26.7-7.3C259.7,220.1,257.4,249.8,255.7,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M255.7,265.4l-48.9-2.5c0.7-23.8-0.6-55.4-1.7-64.2l4.1-5.9c0,0,13.3,13.1,19.5,13.1 c9.3,0,18.5-2.5,26.7-7.3C259.7,220.1,257.4,249.8,255.7,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M232.4,208.4l1,0.8l5.4,4.7c0,0,5.8,23.5,28.5,27.3l4-3.3l-3.1-4c0,0-19.8,0.2-26.7-21.5l0.8-6l-3-0.2 l-4.8-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M225.5,199.1l11.7,6.4l1.1-4.4l4.4,1.9c1.6,0.7,2.4,2.3,2.2,4l-0.8,4.7l-5.9-3.9l-3.4,4.1l-14-8.1 L225.5,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M225.5,199.1l11.7,6.4l1.1-4.4l4.4,1.9c1.6,0.7,2.4,2.3,2.2,4l-0.8,4.7l-5.9-3.9l-3.4,4.1l-14-8.1 L225.5,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M209.3,192.7c0,0-10.9-14.3-8.7-22.9c2.2-8.6,16-26.5,16-26.5l-3.1-4.7c0,0-19.8,16.4-22.7,30.5 c-2.9,14,15.6,48,15.6,48S213.2,199.5,209.3,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M209.3,192.7c0,0-10.9-14.3-8.7-22.9c2.2-8.6,16-26.5,16-26.5l-3.1-4.7c0,0-19.8,16.4-22.7,30.5 c-2.9,14,15.6,48,15.6,48S213.2,199.5,209.3,192.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingGoals);
export default __webpack_public_path__ + "static/media/pending_goals.1c42a863e0a4ea2f16c039e15b4d0815.svg";
export { ForwardRef as ReactComponent };